import { render, staticRenderFns } from "./ChatFaq.vue?vue&type=template&id=dc9d8db2&scoped=true&"
import script from "./ChatFaq.vue?vue&type=script&lang=js&"
export * from "./ChatFaq.vue?vue&type=script&lang=js&"
import style0 from "./ChatFaq.vue?vue&type=style&index=0&id=dc9d8db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9d8db2",
  null
  
)

export default component.exports